import React from 'react'

import Image from 'next/image'

import { Column, Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import { ACCESS_SECTION_GALLERY_ITEMS } from './constants'
import { Card, Container } from './styles'

function Gallery() {
  const { isDesktop, isWideDesktop } = useResponsiveLayout()

  return (
    <Container
      gap={isDesktop || isWideDesktop ? 7 : 6}
      gridTemplateColumns={[
        'repeat(1, 1fr)',
        'repeat(1, 1fr)',
        'repeat(2, 1fr)',
        'repeat(2, 1fr)',
        'repeat(2, 1fr)',
        'repeat(4, 1fr)',
      ]}
    >
      {ACCESS_SECTION_GALLERY_ITEMS.map(item => (
        <Column alignCenter gap={11} key={item.id}>
          <Card height={175} key={item.id}>
            <Image alt={item.caption} fill src={item.image.src} />

            <Image
              alt={item.caption}
              height={70}
              src={item.logo.src}
              width={70}
            />
          </Card>

          <Text body center medium screen20>
            {item.caption}
          </Text>
        </Column>
      ))}
    </Container>
  )
}

export default Gallery
